import React from 'react';
import { Tooltip } from '@myua/kit';
import './styles.scss';

export const WithTooltipPopup: React.FC<{ text: string; trigger: JSX.Element }> = ({
  trigger,
  text,
}) => {
  // antd Tooltip клонирует ребёнка: вешает на него ref и обработчики мыши.
  // С DOM-элементом (<span>, <button>) это работает как есть, а вот
  // функциональный компонент без forwardRef и ref не отдаст, и клонированные
  // onMouseEnter/onMouseLeave просто потеряет — тултип не покажется и не
  // спозиционируется. Semantic такого не требовал (он доставал узел через
  // findDOMNode), поэтому среди 23 точек вызова есть и те, и другие триггеры:
  // например вся панель ContextButtons передаёт компоненты-кнопки.
  // Оборачиваем в span только их, чтобы не менять разметку там, где триггер и
  // так DOM-элемент, и не трогать девять файлов-потребителей.
  const isDomElement = typeof trigger.type === 'string';

  return (
    <Tooltip title={text} placement="top">
      {isDomElement ? trigger : <span className="gen-tooltip-trigger">{trigger}</span>}
    </Tooltip>
  );
};
